(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_shop"] && !Shopify.designMode) return;
  try {
    
  // ============== 主应用模块 ==============
  const CountryMapApp = {
    // 重试计数器
    retryCount: 0,
    //父容器MAX-width 
    baseWidth_map: 1400,
    // DOM元素缓存
    elements: {
      $imgMapAreas: null,
      $mapContainer: null,
      $map_a:null,
      map_areas: null,
    },

    /**
     * 初始化应用
     */
    init: function () {
      console.log('✅ jQuery已加载，版本:', jQuery.fn.jquery);

      $(document).ready(() => {
        this.cacheElements();
        this.initDataAttributes();
        this.bindEvents();
        this.ObserverEvents();
      });
    },

    /**
     * 缓存常用DOM元素
     */
    cacheElements: function () {
      this.elements.$imgMapAreas = $('map .imgMapArea');
      this.elements.$mapContainer = $('map');
      this.elements.$map_a = $('.img_wrap .hover_btn');
      this.elements.map_areas = [];
    },

    /**
     * 初始化数据属性
     */
    initDataAttributes: function () {
      this.elements.$imgMapAreas.each((index, element) => {
        const $area = $(element);
        const countryType = $area.attr('alt');

        // 验证并设置数据
        if (!CountryUtils.validateCountryData(countryType)) {
          console.warn(`未找到国家数据: ${countryType}`);
          return;
        }

        // 获取数据并设置属性
        const countries = CountryUtils.getCountryData(countryType);
        // JQ存储存储国家数据
        $area.data('countries', countries);
        $area.attr('data-countrys', JSON.stringify(countries));
      });
      this.elements.$map_a.each((index, element) => {
            const $area = $(element);
            const countryType = $area.attr('alt');

            // 验证并设置数据
            if (!CountryUtils.validateCountryData(countryType)) {
            console.warn(`未找到国家数据: ${countryType}`);
            return;
            }

            // 获取数据并设置属性
            const countries = CountryUtils.getCountryData(countryType);
            // JQ存储存储国家数据
            $area.data('countries', countries);
            $area.attr('data-countrys', JSON.stringify(countries));
      });
    },

    /**
     * 绑定事件
     */
    bindEvents: function () {
      // 事件委托
      this.elements.$mapContainer.on(
        {
          // 鼠标悬停事件
          mouseenter: function () {
            const tabIndex = $(this).index() + 1;
            $(`.hover_btn${tabIndex}`).addClass('hover');
          },
          mouseleave: function () {
            const tabIndex = $(this).index() + 1;
            $(`.hover_btn${tabIndex}`).removeClass('hover');
          },
          // 点击事件
          click: function (e) {
            e.preventDefault();
            CountryMapApp.handleCountryClick($(this));
          },
        },
        '.imgMapArea'
      );
      this.elements.$map_a.on({
          click:function(e)
          {
             e.preventDefault();
             console.log("被点击")
             CountryMapApp.handleCountryClick($(this));
          }
      });
    },

    /**
     * 事件监听
     */
    ObserverEvents: function () {
      this.initAreaCoordinates();
      this.setupResizeObserver();
    },

    initAreaCoordinates: function () {
      this.elements.map_areas = [];
      this.elements.$imgMapAreas.each((index, area) => {
        const $area = $(area);
        const originalCoords = $area.attr('coords').split(',').map(Number);
        this.elements.map_areas.push({
          element: area,
          $element: $area,
          originalCoords: originalCoords,
          shape: $area.attr('shape'),
        });
      });
    },
    setupResizeObserver: function () {
        // 设置观察者容器
        const mapContainer = this.elements.$mapContainer.parent()[0];
        if (!mapContainer) {
            console.warn('未找到地图容器，无法监听尺寸变化');
            return;
        }
        this.observer = new ResizeObserver((entries) => {
            if (this.resizeFrameId) {
            cancelAnimationFrame(this.resizeFrameId);
            }
            this.resizeFrameId = requestAnimationFrame(() => {
            const currentWidth = entries[0].contentRect.width;
            this.updateAreaCoordinates(currentWidth, this.baseWidth_map);
            this.resizeFrameId = null;
            });
        });

        //  观察者开启
        this.observer.observe(mapContainer);
        console.log("this->",this)
        console.log('ResizeObserver已启动，监听容器:', mapContainer);
    },
    // 更改热区坐标
    updateAreaCoordinates: function (currentWidth, baseWidth) {
      if (!this.elements.map_areas || this.elements.map_areas.length === 0) {
        return;
      }

      const scale = currentWidth / baseWidth;

      this.elements.map_areas.forEach((areaInfo) => {
        const newCoords = areaInfo.originalCoords.map((coord) => Math.round(coord * scale));
        // 使用缓存的jQuery对象更新coords属性
        areaInfo.$element.attr('coords', newCoords.join(','));
      });

    //   console.log(`坐标已更新（缩放比例: ${scale.toFixed(3)}）`);
    },

    /**
     * 处理国家点击事件
     */
    handleCountryClick: function ($area) {
      try {
        
        const countryType = $area.attr('alt');
        console.log(countryType)
        // 获取国家数据
        let countries = $area.data('countries');
        console.log(countries)
        if (!countries || countries.length === 0) {
          const dataAttr = $area.attr('data-countrys');
          countries = CountryUtils.safeParseJSON(dataAttr, []);
        }

        if (!countries || countries.length === 0) {
          console.error('未找到国家数据');
          return;
        }

        // 生成传输ID并保存数据
        const transferId = CountryUtils.generateTransferId(countryType);
        const saveSuccess = CountryUtils.saveToStorage(transferId, countries, countryType);

        if (saveSuccess) {
          // 打开新窗口
          const targetUrl = CountryUtils.getTargetUrl(transferId);
          window.open(targetUrl, '_blank', 'noopener,noreferrer');
        }
      } catch (error) {
        console.error('处理点击事件时出错:', error);
      }
    },

    /**
     * 降级方案（原生JS实现）
     */
    fallbackImplementation: function () {
      console.log('使用原生JavaScript实现');
      document.addEventListener('DOMContentLoaded', () => {
        const areas = document.querySelectorAll('map .imgMapArea');

        areas.forEach(function (area) {
          const countryType = area.getAttribute('alt');

          // 设置数据
          if (CountryUtils.validateCountryData(countryType)) {
            const countries = CountryUtils.getCountryData(countryType);
            area.dataset.countrys = JSON.stringify(countries);
          }

          // 添加事件监听
          area.addEventListener('click', function (e) {
            e.preventDefault();
            const data = CountryUtils.safeParseJSON(this.dataset.countrys, []);
            if (data.length > 0) {
              const transferId = CountryUtils.generateTransferId(countryType);
              CountryUtils.saveToStorage(transferId, data, countryType);
              const targetUrl = CountryUtils.getTargetUrl(transferId);
              window.open(targetUrl, '_blank');
            }
          });
        });
      });
    },

    /**
     * 检查jQuery并初始化
     */
    checkAndInitialize: function () {
      if (CountryUtils.isJQueryLoaded()) {
        this.init();
      } else if (this.retryCount < CONFIG.MAX_RETRIES) {
        this.retryCount++;
        console.log(`❌ jQuery未加载，重试 ${this.retryCount}/${CONFIG.MAX_RETRIES}`);
        setTimeout(() => this.checkAndInitialize(), CONFIG.RETRY_INTERVAL);
      } else {
        console.error('❌ jQuery加载失败，已达到最大重试次数');
        this.fallbackImplementation();
      }
    },
  };

  // ============== 启动应用 ==============
  // 等待工具模块加载完成
  function initApp() {
    // 检查全局变量是否已加载
    if (typeof CountryUtils !== 'undefined') {
      CountryMapApp.checkAndInitialize();
    } else {
      // 如果工具模块未加载，等待一段时间再试
      setTimeout(initApp, 100);
    }
  }

  // 当页面加载完成时启动应用
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApp);
  } else {
    initApp();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
